const ALLOWED_TAGS = new Set([
  "p",
  "br",
  "ul",
  "ol",
  "li",
  "strong",
  "em",
  "b",
  "i",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "blockquote",
]);

function sanitizeNode(node: Node, doc: Document): Node | null {
  if (node.nodeType === Node.TEXT_NODE) return node.cloneNode();
  if (node.nodeType !== Node.ELEMENT_NODE) return null;

  const el = node as Element;
  const tag = el.tagName.toLowerCase();

  const processedChildren: Node[] = [];
  for (const child of Array.from(el.childNodes)) {
    const processed = sanitizeNode(child, doc);
    if (processed) processedChildren.push(processed);
  }

  if (ALLOWED_TAGS.has(tag)) {
    const newEl = doc.createElement(tag);
    for (const child of processedChildren) newEl.appendChild(child);
    return newEl;
  }

  // Unwrap disallowed element — keep its children
  const fragment = doc.createDocumentFragment();
  for (const child of processedChildren) fragment.appendChild(child);
  return fragment;
}

export function sanitizeHtml(html: string): string {
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html");
  const root = doc.body.firstChild as Element;

  const container = doc.createElement("div");
  for (const child of Array.from(root.childNodes)) {
    const processed = sanitizeNode(child, doc);
    if (processed) container.appendChild(processed);
  }

  return container.innerHTML;
}
